import React from 'react';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 32 }}>
    <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 12, color: '#111' }}>{title}</h2>
    <div style={{ color: '#374151', lineHeight: 1.8, fontSize: 15 }}>{children}</div>
  </div>
);

export default function PrivacyPolicy() {
  return (
    <div className="container" style={{ maxWidth: 820 }}>
      <h1 style={{ marginBottom: 6 }}>Privacy Policy</h1>
      <p style={{ color: '#6b7280', marginBottom: 36 }}>Last updated: July 2026</p>

      <Section title="1. Information We Collect">
        <p>When you place an order or create an account with StyleMe, we collect:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li>Name, email address, phone number</li>
          <li>Shipping address</li>
          <li>Order history and transaction details</li>
          <li>Device and browser information for security purposes</li>
        </ul>
      </Section>

      <Section title="2. How We Use Your Information">
        <p>We use your information to:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li>Process and fulfill your orders</li>
          <li>Send order confirmations and shipping updates</li>
          <li>Respond to customer service inquiries</li>
          <li>Improve our website and services</li>
          <li>Comply with legal obligations</li>
        </ul>
        <p style={{ marginTop: 12 }}>We do <strong>not</strong> sell, trade, or rent your personal information to third parties.</p>
      </Section>

      <Section title="3. Payment Information">
        <p>All payment processing is handled securely by Stripe. StyleMe does not store your full credit card number, CVV, or payment card details on our servers. Stripe's privacy policy governs the handling of payment data.</p>
      </Section>

      <Section title="4. Cookies">
        <p>We use essential cookies to keep you logged in and maintain your shopping cart. We do not use advertising or tracking cookies.</p>
      </Section>

      <Section title="5. Data Sharing">
        <p>We share your information only with:</p>
        <ul style={{ paddingLeft: 20, marginTop: 8 }}>
          <li><strong>Shipping carriers</strong> (USPS, FedEx, UPS) to deliver your orders</li>
          <li><strong>Stripe</strong> for payment processing</li>
          <li>Law enforcement if required by law</li>
        </ul>
      </Section>

      <Section title="6. Data Retention">
        <p>We retain your order and account information for up to 5 years for accounting and legal compliance purposes. You may request deletion of your account by contacting us.</p>
      </Section>

      <Section title="7. Your Rights">
        <p>You have the right to access, correct, or delete your personal data. To exercise these rights, contact us at <a href="mailto:support@styleme.club">support@styleme.club</a>.</p>
      </Section>

      <Section title="8. Contact Us">
        <p>If you have any questions about this Privacy Policy, please contact us at:<br />
        📧 <a href="mailto:support@styleme.club">support@styleme.club</a></p>
      </Section>
    </div>
  );
}
